var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhereToWatchIndicator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91732 8.47224V11.721C8.91732 11.8767 9.08405 11.9716 9.21259 11.8891L11.7433 10.2647C11.8642 10.1871 11.8642 10.0062 11.7433 9.92857L9.21259 8.30417C9.08405 8.22166 8.91732 8.31657 8.91732 8.47224Z",
    fill: "#505B73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75065 5.44037H15.2507C16.0331 5.44037 16.6673 6.07463 16.6673 6.85704V13.1904C16.6673 13.9728 16.0331 14.607 15.2507 14.607L13.334 14.607V15.4404H6.66732V14.607L4.75065 14.607C3.96825 14.607 3.33398 13.9728 3.33398 13.1904V6.85704C3.33398 6.07463 3.96825 5.44037 4.75065 5.44037ZM4.75065 6.69037C4.6586 6.69037 4.58398 6.76499 4.58398 6.85704V13.1904C4.58398 13.2824 4.6586 13.357 4.75065 13.357H15.2507C15.3427 13.357 15.4173 13.2824 15.4173 13.1904V6.85704C15.4173 6.76499 15.3427 6.69037 15.2507 6.69037H4.75065Z",
    fill: "#505B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhereToWatchIndicator);
export default __webpack_public_path__ + "static/media/where-to-watch-indicator.a796de3b9c232f35c9cb28d8684b8028.svg";
export { ForwardRef as ReactComponent };